module.exports = __webpack_public_path__ + "img/11.8360d768.png";